
import React, {Component} from 'react';
import { Switch } from 'react-router';
import {Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DatabaseService from 'services/DatabaseService.js';
import UserService from 'services/UserService.js';
import {fetchMyProfile} from 'actions/user.js';
import {fetchBadgeNumbers} from 'actions/user.js';

import PageNotFound                   from 'modules/main/PageNotFound.js';
import DefaultLayout                  from 'modules/main/DefaultLayout.js';
import SignUpContainer                from 'modules/authentication/SignUpContainer.js';
import LogInContainer                 from 'modules/authentication/LogInContainer.js';
import ChoosePasswordContainer        from 'modules/authentication/ChoosePasswordContainer.js';
import PasswordChangedContainer       from 'modules/authentication/PasswordChangedContainer.js';
import EmailVerifiedContainer         from 'modules/settings/EmailVerifiedContainer.js';
import ProfileContainer               from 'modules/profile/ProfileContainer.js';
import UserEditContainer              from 'modules/profile/UserEditContainer.js';
import Welcome                        from 'modules/onboarding/Welcome.js';
import PersonalContainer              from 'modules/onboarding/PersonalContainer.js';
import HealthContainer                from 'modules/onboarding/HealthContainer.js';
import SatisfactionContainer          from 'modules/onboarding/SatisfactionContainer.js';
import AnnouncementsContainer         from 'modules/newsfeed/AnnouncementsContainer.js';
import NewsFeed                       from 'modules/newsfeed/NewsFeed.js'
import MyProgressContainer            from 'modules/newsfeed/MyProgressContainer.js'
import RewardsContainer               from 'modules/rewards/RewardsContainer.js';
import InvitationsContainer           from 'modules/invitations/InvitationsContainer.js';
import LeaderboardsContainer          from 'modules/leaderboards/LeaderboardsContainer.js';
import LeaderboardSelectorContainer   from 'modules/leaderboards/LeaderboardSelectorContainer.js';
import PluginsContainer               from 'modules/plugins/PluginsContainer.js';
import SettingsContainer              from 'modules/settings/SettingsContainer.js';
import TodayContainer                 from 'modules/challenges/TodayContainer.js';
import TeamChallengesContainer        from 'modules/teamchallenges/TeamChallengesContainer.js';
import TeamChallengeContainer         from 'modules/teamchallenges/TeamChallengeContainer.js';
import MyTeamContainer                from 'modules/teamchallenges/MyTeamContainer.js';
import SelectTeamContainer            from 'modules/teamchallenges/SelectTeamContainer.js';
import SetGoalsContainer              from 'modules/categories/SetGoalsContainer.js';
import SetGroupContainer              from 'modules/authentication/SetGroupContainer.js';
import CategoriesContainer            from 'modules/categories/CategoriesContainer.js';
import CategoryContainer              from 'modules/categories/CategoryContainer.js';
import SectionsContainer              from 'modules/categories/SectionsContainer.js';
import ObjectivesContainer            from 'modules/objectives/ObjectivesContainer.js';
import ChallengeLoaderContainer       from 'modules/challenges/ChallengeLoaderContainer.js';
import SurveyContainer                from 'modules/surveys/SurveyContainer.js';
import MyHealthContainer              from 'modules/surveys/MyHealthContainer.js';
import TermsOfUse                     from 'modules/TermsOfUse.js';
import OnboardingContainer            from 'modules/onboarding/v2/OnboardingContainer.js';
import SeasonContainer                from 'modules/challenges/SeasonContainer.js';
import TestPage                       from 'modules/misc/TestPage.js';

const setGroupPath   = '/setgroup';
const onboardingPath = '/onboarding';
const loginPath      = '/login';

class AppContent extends Component {
    componentWillMount() {
        if(this.props.isLoggedIn) {
            this.loadAppData();
        }
        this.handleRedirects(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isLoggedIn===true && nextProps.isLoggedIn!==this.props.isLoggedIn) {
            this.loadAppData();
        }
    }

    componentDidUpdate(prevProps) {
        this.handleRedirects(this.props);
    }

    handleRedirects(props) {
        var noCompanyRedirect=Boolean(props.noCompany && 
                                      props.location.pathname!==setGroupPath &&
                                      props.isLoggedIn); 

        if(noCompanyRedirect) {
            console.log('AppContent - noCompanyRedirect redirecting to setGroup')
            this.props.history.replace(setGroupPath);
            return;
        } 
    }

    loadAppData() {
        console.log('AppContent.loadAppData');
        this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:true});
        return this.props.dispatch(fetchMyProfile({surveys:true, plugins:true, features:true, health:true, rank:true, categories:true}))
            .then((settings) => {
                var surveys = DatabaseService.getSurveysCache();
                console.log('AppContent.loadAppData - checking for onboarding survey', {surveys:surveys, noCompany:this.props.noCompany});
                var doOnboarding = Boolean(surveys && surveys.onboarding && surveys.onboarding.id && !this.props.noCompany);
                if(doOnboarding) {
                    console.log('AppContent - doOnboarding redirecting to onboarding')
                    this.props.history.replace(onboardingPath+this.props.history.location.search);
                }
                return this.props.dispatch(fetchBadgeNumbers());
            }).catch(error => {
                console.error('loadAppData', error);
            }).then(() =>{
                //Always
                this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
            });
    }
    
    render()
    {
        var never = false;
        var always = true;
        var loggedIn=this.props.isLoggedIn;
        return (
            <DefaultLayout showNavbar={this.props.showNavbar} showSidebar={this.props.showSidebar} navbarMode={this.props.navbarMode} >
                <Switch>
                    {/* <Route path='/apple-app-site-association' component={() => { 
                        alert('1')
                        window.location.href = '/apple-app-site-association'; 
                        return null;
                    }}/>
                    <Route path='/.well-known/assetlinks.json' component={() => { 
                        window.location.href = '/.well-known/assetlinks.json'; 
                        return null;
                    }}/> */}
                  {/* <Redirect from="/apple-app-site-association" to={window.location.origin + "/apple-app-site-association"} />
                  <Redirect from="/.well-known/assetlinks.json" to={window.location.origin + "/.well-known/assetlinks.json"} /> */}
                  <RedirectRoute exact path="/"                       component={SignUpContainer}              when={loggedIn}  to={onboardingPath}/>
                  <RedirectRoute path="/register"                     component={SignUpContainer}              when={loggedIn}  to={onboardingPath}/>
                  <RedirectRoute path={loginPath}                     component={LogInContainer}               when={loggedIn}  to={onboardingPath}/>
                  <RedirectRoute path="/choose-password"              component={ChoosePasswordContainer}      when={never}/>
                  <RedirectRoute path="/password-changed"             component={PasswordChangedContainer}     when={never}/>
                  <RedirectRoute path={onboardingPath}                component={OnboardingContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/newsfeed"                     component={NewsFeed}                     when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/myprogress"                   component={MyProgressContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/feed/me"                      component={MyProgressContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/feed"                         component={NewsFeed}                     when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/announcements/:id"            component={AnnouncementsContainer}       when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/announcements"                component={AnnouncementsContainer}       when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/settings"                     component={SettingsContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/verify-email"                 component={EmailVerifiedContainer}       when={never}/>
                  <RedirectRoute path="/profile"                      component={ProfileContainer}             when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/profile/me"                   component={ProfileContainer}             when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/editprofile"                  component={UserEditContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/home"                         component={TodayContainer}               when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/logs/:id"                     component={TodayContainer}               when={!loggedIn} to={loginPath} cprops={{selectLogCategory:true, key:'logs'}}/>
                  <RedirectRoute path="/myhealth/:id"                 component={MyHealthContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/surveys/:id"                  component={SurveyContainer}              when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/survey/:id"                   component={SurveyContainer}              when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/msurvey/:id"                  component={SurveyContainer}              when={!loggedIn} to={loginPath} cprops={{micro:true}}/>
                  <RedirectRoute path="/setgoals"                     component={SetGoalsContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path={setGroupPath}                  component={SetGroupContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path='/switchgroup'                  component={SetGroupContainer}            when={!loggedIn} to={loginPath} cprops={{isSwitch:true}}/>
                  <RedirectRoute path="/objectives/:id"               component={CategoriesContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/objectives"                   component={ObjectivesContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/categories/:id/:on?"          component={CategoryContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/categories"                   component={CategoriesContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/sections/:id"                 component={SectionsContainer}            when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/challenges/:id"               component={ChallengeLoaderContainer}     when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/activities/:id"               component={ChallengeLoaderContainer}     when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/team-challenge/active"        component={MyTeamContainer}              when={!loggedIn} to={loginPath} cprops={{key:'active', mode:'active'}}/>
                  <RedirectRoute path="/team-challenge/invitations"   component={MyTeamContainer}              when={!loggedIn} to={loginPath} cprops={{key:'invitations', mode:'invitations'}}/>
                  <RedirectRoute path="/team-challenge/history"       component={MyTeamContainer}              when={!loggedIn} to={loginPath} cprops={{key:'history', mode:'history'}}/>
                  <RedirectRoute path="/team-challenges/records/:id"  component={TeamChallengeContainer}       when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/team-challenges/:id"          component={TeamChallengeContainer}       when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/team-challenges"              component={TeamChallengesContainer}      when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/myteamchallenge/:id"          component={TeamChallengeContainer}       when={!loggedIn} to={loginPath} cprops={{completeScreen:true}}/>
                  <RedirectRoute path="/selectteam/:id"               component={SelectTeamContainer}          when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/rewards"                      component={RewardsContainer}             when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/invitations"                  component={InvitationsContainer}         when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/leaderboards/:id"             component={LeaderboardSelectorContainer} when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/leaderboards"                 component={LeaderboardsContainer}        when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/connections"                  component={PluginsContainer}             when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/seasons/:id/categories"       component={SeasonContainer}              when={!loggedIn} to={loginPath} cprops={{categories:true}}/>
                  <RedirectRoute path="/seasons/:id"                  component={SeasonContainer}              when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/testpage"                     component={TestPage}                     when={!loggedIn} to={loginPath}/>
                  <RedirectRoute path="/terms"                        component={TermsOfUse}                   when={never}/>
                  <RedirectRoute path="/oauth2callback.html"          /*no component*/                         when={always}    to={sessionStorage.oauth2callbackRedirect || '/connections'} preserveSearch />
                  <RedirectRoute path="*"                             component={PageNotFound}                 when={!loggedIn} to={loginPath}/>
                </Switch> 
            </DefaultLayout>
        );
    }
}




const RedirectRoute = ({ component: Component, when, to, preserveSearch, cprops, ...rest }) => {
  return (<Route {...rest} render={props => (
        when ? (
          <Redirect to={{
            pathname: to,
            search: (preserveSearch ? props.location.search : undefined),
            state: { from: props.location }
          }}/>
        ) : (
          <Component {...props} {...cprops}/>
        )
      )}/>
    );
}




const mapAppContentProps = (state, ownProps) => {
    return { isLoggedIn   :state.user.loggedIn, 
             noCompany    :state.user.noCompany, 
             showNavbar   :state.navbar.enable, 
             showSidebar  :state.sidebar.enable, 
             navbarMode   :state.navbar.mode};
}
export default withRouter(connect(mapAppContentProps)(AppContent));



// WEBPACK FOOTER //
// ./src/modules/main/AppContent.js